import React from "react";
import PropTypes from "prop-types";

const label = status => {
  switch (status) {
    case true:
      return "List";
    case false:
      return "Do Not List";
    default:
      return "None";
  }
};

export default function ListingOverrideLabel({ status }) {
  return <span>{label(status)}</span>;
}

ListingOverrideLabel.propTypes = {
  status: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/ListingOverrideLabel.jsx